<template>
    <!--  共享大类维护页面-->
    <div class="commodityMaintenanceBox">
<!--        <div class="h-crumbOut">-->
<!--            <div class="h-crumbs">-->
<!--                <el-breadcrumb separator="|">-->
<!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item>共享商品维护</el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
<!--            </div>-->
<!--        </div>-->
      <Breadtabsheader/>
        <!--    搜索开始-->
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" ref="q" :model="q" class="demo-form-inline h-formBorder" label-width="120px">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="产品大类" prop="levelCode">
                            <brselectlazy category="product_level" :v="q.proModelCode" v-model="q.proModelCode"
                                          :clearable="true"
                                          style="width:100%"/>
                        </el-form-item>

                        <el-form-item label="产品编号" prop="productId">
                            <el-input v-model.trim="q.productId" placeholder="" @keyup.enter.native="handleFilter" maxlength="255" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="产品名称" prop="productName">
                            <el-input v-model.trim="q.productName" placeholder="" @keyup.enter.native="handleFilter" maxlength="255" clearable></el-input>
                        </el-form-item>

                        <el-form-item label="共享大类" prop="levelCode">
                            <brselectlazy category="product_level" :v="q.shareModelCode" v-model="q.shareModelCode"
                                          :clearable="true"
                                          style="width:100%"/>
                        </el-form-item>
                    </div>
                    <div class="h-thirdColumn w-newColumn">
                      <el-form-item label="创建人/编码" prop="cuname">
                        <el-input v-model.trim="q.cuname" placeholder="" @keyup.enter.native="handleFilter" maxlength="255" clearable></el-input>
                      </el-form-item>
                      <el-form-item  label="创建日期">
                        <el-date-picker type="date" placeholder="选择日期" v-model="q.cdate"
                                        value-format="yyyy-MM-dd" style="width: 100%;">
                        </el-date-picker>
                      </el-form-item>
                  </div>
                </el-form>
                <!-- 修改 操作按钮位置 -->
                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <!-- <el-form-item class="right-btn"> -->
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetForm('q')">重置</el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="addEditDialog('','add')">新增
                        </el-button>
                        <!-- </el-form-item> -->
                    </div>
                </div>
            </div>
        </div>
        <!--    搜索结束-->
        <!--    表格开始-->
        <div class="h-table h-mrt30 Ju">
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    style="width: 100%"
                    :border="true"
                    max-height="440"
            >
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>

                <el-table-column
                        prop="productId"
                        label="产品编号"
                        min-width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="productName"
                        label="产品名称"
                        min-width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="proModelCode"
                        label="产品大类编号"
                        min-width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="产品大类名称"
                        min-width="150"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>


                <el-table-column
                        prop="shareModelCode"
                        label="共享大类编号"
                        min-width="150"
                        :show-overflow-tooltip="true"
                >

                </el-table-column>
                <el-table-column
                        prop="shareModelName"
                        label="共享大类名称"
                        min-width="150"
                        :show-overflow-tooltip="true"
                >

                </el-table-column>

              <el-table-column
                  prop="cuname"
                  label="创建人"
                  min-width="150"
                  :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                  prop="cdate"
                  label="创建时间"
                  min-width="150"
                  :show-overflow-tooltip="true"
              >
              </el-table-column>
                <el-table-column
                        label="操作"
                        width="100"
                        fixed="right"

                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" class="h-tableLink h-btn"
                                   @click="delPlan(scope.$index,scope.row)">删除
                        </el-button>

                    </template>
                </el-table-column>

            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="outexcel">批量导出
                    </el-button>
                </div>
                <div class="h-pagination2">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="q.pageNo"
                            :page-sizes="[10,50,100,500]"
                            :page-size="q.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="q.total"></el-pagination>
                </div>
            </div>
        </div>

        <!--    表格结束-->
        <!--    新增和编辑弹窗开始-->
        <el-dialog :close-on-click-modal="false" class="new-dialog" :visible.sync="dialogFormVisible">
            <!-- dialogImg -->
            <div class="h-dialogImg">
                <h3>{{ this.title }}</h3>
            </div>
            <el-form :model="addEditFrom" ref="addEditFrom" label-width="80px" :rules="rules" :inline="true" size="mini"
                     class="addDeliveryForm">
                <el-form-item v-if="addEditFrom.optionsType === 'add'" label="产品大类" prop="proModelCode">
                    <brselectlazy category="product_level" :v="addEditFrom.proModelCode" @change="callFun"
                                  v-model="addEditFrom.proModelCode"
                                  :clearable="true"
                    />
                </el-form-item>
                <el-form-item v-else label="产品大类" prop="proModelName">
                    <el-select v-model="addEditFrom.proModelName"
                               disabled
                               clearable>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品名称" prop="productName">
                    <!-- @change="productChange" -->
                    <el-select v-model="addEditFrom.productName" placeholder="请选择"  @change="productChange"
                               filterable>
                        <el-option v-for="item in productNameArr" :key="item.levelname"
                                   filterable :label="item.levelname" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="产品编号" prop="productId">
                    <el-select v-model="addEditFrom.productId" placeholder="请选择"  @change="productCode"
                               filterable>
                        <el-option v-for="item in proudctLevelArr" :key="item.id"
                                   filterable :label="item.id" :value="item">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model.trim="addEditFrom.productId" disabled placeholder="" maxlength="255" clearable></el-input> -->
                </el-form-item>

                <el-form-item v-if="addEditFrom.optionsType === 'add'" label="共享大类" prop="shareModelCode">
                    <brselectlazy category="product_level" :v="addEditFrom.shareModelCode" @change="callFun1"
                                  v-model="addEditFrom.shareModelCode"
                                  :clearable="true"
                    />
                </el-form-item>
                <el-form-item v-else label="共享大类" prop="shareModelName">
                    <el-select v-model="addEditFrom.shareModelName"
                               disabled
                               clearable>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="()=>dialogFormVisible=false">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submit">确 定</el-button>
            </div>
        </el-dialog>

        <!--    新增和编辑弹窗结束-->
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    import updownfile from "../../utils/updownfile";

    export default {

        name: "shareModel",
        data() {
            return {

                q: {  //搜索表单
                    proModelCode: '',//产品大类编号
                    proModelName: '',//产品大类名称
                    productName: '',//产品名称
                    productId: '',//产品编码
                    shareModelCode: '',//
                    shareModelName:'',
                    cuname:'',    //创建人
                    cdate:'',     //创建时间
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,

                },
                //新增和编辑
                addEditFrom: {
                    proModelCode: '',//产品大类编号
                    proModelName: '',//产品大类名称
                    productName: '',//产品名称
                    productId: '',//产品id
                    shareModelCode: '',//
                    shareModelName:'',
                    cuname:'',
                    cdate:'',
                  },
                rules: {
                    proModelCode: [
                        {required: true, message: '请选择产品大类', trigger: 'blur'},
                    ],
                    productName: [
                        {required: true, message: '请输入产品名称', trigger: 'blur'},
                    ],
                    shareModelCode: [
                        {required: true, message: '请选择共享大类', trigger: 'blur'},
                    ],
                },
                dialogFormVisible: false,//新增和编辑弹窗开关
                title: '共享大类维护',
                productNameArr: [],//弹窗中产品名称集合
                proudctLevelArr:[],
                tableData: [], //表格数据集合
            }
        },

        //加载页面默认执行
        created() {
            this.query();

        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        activated() {
            this.query();
        },


        methods: {
            curChange() {//点击分页调用
                this.query();
            },
            handleSizeChange(val) {
                console.log(val)
                this.q.pageNo = 1
                this.q.pageSize = val
                this.query()
            },
            handleCurrentChange(val) {
                console.log(val)
                this.q.pageNo = val;
                this.query()
            },
            //产品名称选择回调
            productChange(e) {
                if (e) {
                    this.$set(this.addEditFrom, 'productName', e.levelname);//产品名称
                    this.$set(this.addEditFrom, 'productId', e.id);//产品编码
                } else {
                    this.$set(this.addEditFrom, 'productName', '');//产品名称
                    this.$set(this.addEditFrom, 'productId', '');//产品编码
                }
            },
            productCode(e){
                if (e) {
                    this.$set(this.addEditFrom, 'productId', e.id);//产品编码
                    this.$set(this.addEditFrom, 'productName', e.levelname);//产品名称
                } else {
                    this.$set(this.addEditFrom, 'productId', '');//产品编码
                    this.$set(this.addEditFrom, 'productName', '');//产品名称
                }
            },
            callFun(obj) {
                let id = this.addEditFrom.proModelCode;
                this.$set(this.addEditFrom, 'proModelName', obj.name); //产品大类名称
                this.$set(this.addEditFrom,'productId', obj.productCate)
                id && this.selectProduct2Cg(id)
            },
            callFun1(obj){
                let id = this.addEditFrom.shareModelCode;
                this.$set(this.addEditFrom, 'shareModelName', obj.name); //产品大类名称
            },
            //大类修改时，查询小类列表 v.type大类id-v,index-i  (产品名称下拉获取)
            selectProduct2Cg(id) {
                ss.ProService.product2OemSelectReal(id).then(rd => {
                    this.productNameArr = rd;
                    this.proudctLevelArr = rd
                })
            },

            //提交
            submit() {
                let obj = JSON.parse(JSON.stringify(this.addEditFrom))
                //新增
                if (this.addEditFrom.optionsType === 'add') {
                    ss.chanpin.insertShareModel(obj).then(res => {
                        if (res.f == true) {
                            this.$message.success(res.msg);
                            this.dialogFormVisible = false;
                            this.query();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                } /*else if (this.addEditFrom.optionsType === 'edit') {
                    //修改
                    ss.chanpin.updateSendTypeN(obj).then(res => {
                        if (res.f == true) {
                            this.$message.success(res.msg);
                            this.dialogFormVisible = false;
                            this.query();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }*/


            },
            //点击新增或编辑
            addEditDialog(row, type) {
                this.dialogFormVisible = true;
                if (type == 'edit') { //编辑

                } else {
                    this.title = '共享大类新增';
                    this.proudctLevelArr = []
                    this.addEditFrom.productId = ''
                    console.log(this.title)

                    this.$set(this.addEditFrom, 'optionsType', 'add');
                    this.$set(this.addEditFrom, 'proModelCode', '');//产品大类编号
                    this.$set(this.addEditFrom, 'proModelName', '');//产品大类编号
                    this.$set(this.addEditFrom, 'productName', '');//产品名称
                    this.$set(this.addEditFrom, 'shareModelCode', '');//共享产品大类编号
                    this.$set(this.addEditFrom, 'shareModelName', '');//共享产品大类名称
                }

            },
            formatter(row, column) {
                let prop = column.property;   //获取当前列的prop设置的key
                if (row[prop] == 0) {
                    return '否'
                } else if (row[prop] == 1) {
                    return '是'
                } else {
                    return ''
                }
            },
//导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
                this.query();
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },


            //重置
            resetForm(formName) {
                this.q.productId='';
                this.q.productName='';
                this.q.proModelCode='';
                this.q.shareModelCode='';
                this.q.cuname='',
                this.q.cdate='',
                this.query();
            },


            //查询翻页
            query() {
                ss.chanpin.selectShareModel(this.q).then(res => {
                    if (res.f == true) {
                        this.q.total = res.obj.total;
                        this.tableData = res.obj.records;

                    } else {
                        this.$message.error(res.msg);
                    }
                })
            },


            handleFilter() {
                this.q.pageNo = 1;
                this.query();
            },


            handleSelectionChange(val) {

                console.log(val)
                this.multipleSelection = val;
            },
            //删除框
            delPlan(index, q) {

                console.log(q, 'qaaaaa')

                this.$confirm('确认删除？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
                    .then(_ => {

                        //如果原来有数据
                        let arr = [];
                        if (q.id != null) {//把要删除的主键id存起来
                            arr.push(q.id);
                            ss.chanpin.deleteShareModel(arr).then(res => {
                                if (res.f == true) {
                                    this.$message.success(res.msg);
                                    this.dialogFormVisible = false;
                                    this.query();
                                } else {
                                    this.$message.error(res.msg);
                                }
                            })
                        }

                    })
                    .catch(_ => {

                    });

            },

            //导表
            outexcel() {
              //明细导出
              updownfile.down("/api/swyl/v1/demo/bscsharemodel/downloadExcel",this.q,"post",'data');
            },
        },


        mounted() {
            // this.status = sessionStorage.priceManage?sessionStorage.priceManage:1;
            // if(sessionStorage.priceManage != 2){
            // 	this.showOrhide = true;
            // }
        },
    }
</script>
<style scoped>
    .commodityMaintenanceBox > .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 3rem !important;
    }
</style>
<style>
    .Ju .h-btn.el-button.h-tableLink {
        padding: 0 0.05rem;
    }

</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step1 {
            top: 0;
            left: 0;
        }

        .step2 {
            top: 0;
            left: 0;
        }

        .step3 {
            top: 0;
            left: 0;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }

    }
</style>
<!--弹窗样式开始-->
<style scoped>
    .commodityMaintenanceBox > .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 3rem !important;
    }

    /deep/ .el-dialog__header {
        padding: 0
    }

    /deep/ .el-dialog {
        border-radius: 0.1rem;
        width: 7.89rem;
    }

    /deep/ .el-dialog__body {
        padding: 0;
    }

    /deep/ .el-dialog__header {
        background: #2785E7
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
        height: 0.56rem;
        width: 0.56rem;
        line-height: 0.56rem;
        text-align: center;
        background-color: #fff;
        color: #015ba0;
        border-radius: 100%;
        font-size: 0.34rem;
    }

    .h-dialogImg {
        height: 1.62rem;
        background: url(/img/h-dialogImg.471fa846.png) center no-repeat;
        background-size: 7.89rem;
        padding-left: 4.02rem;
    }

    .h-dialogImg h3 {
        text-align: left;
        padding: .6rem 0 0 0;
        font-size: 0.3rem;
        color: #fff;
        font-weight: normal;
        letter-spacing: 0.02rem;
    }

    .addDeliveryForm {
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .addDeliveryForm /deep/ .el-form-item{
        width: 48%;
        float: left;
    }
    .addDeliveryForm /deep/ .el-form-item__label {
        width: 84px;
        font-size: 0.18rem;
        color: #4a4a4a;
        line-height: 0.28rem;
        vertical-align: top;
        padding-right: 5px;
        letter-spacing: 0;
        display: inline-block;
        text-align: right;
    }
    .addDeliveryForm /deep/ .el-form-item__content {
        width: 67%
    }
    .addDeliveryForm /deep/ .el-form-item__content .el-input__inner {
        border-radius: 0;
        background: transparent;
        color: #868686;
        border: 0;
        border-bottom: 1px solid #dedede;
        height: 0.29rem;
        line-height: 0.28rem;
        padding-left: 0.15rem;
    }

</style>
<!--弹窗样式结束-->

